import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import siteConfig from "../config/siteConfig";
import "../css/about.scss";

function About() {
  useEffect(() => {
    document.title = `Our Story — ${siteConfig.brandName}`;
  }, []);

  return (
    <main className="about">
      <section className="about-hero">
        <div className="about-hero__copy">
          <p className="eyebrow">Our Story</p>
          <h1>Choose well.<br /><em>Walk well.</em></h1>
          <p>tastevani brings together contemporary footwear designed to fit effortlessly into everyday life.</p>
        </div>
        <img src="/img/editorial/about-hero.jpg" alt="Original olive flexible shoe in a clean studio setting" />
      </section>

      <section className="about-letter shell">
        <span>TASTEVANI</span>
        <div>
          <p className="eyebrow">A focused selection</p>
          <h2>Style starts with the right pair.</h2>
          <p>Our catalogue is built around one simple principle: offer footwear only and provide the essential details before purchase.</p>
          <p>Every style lists its sizes, materials, colours and fit guidance to make choosing easier.</p>
        </div>
      </section>

      <section className="about-image-break">
        <img src="/img/editorial/about-collection.jpg" alt="Original cobalt sneaker in a clean studio setting" loading="lazy" />
        <blockquote>“Easy-to-wear styles, easy-to-understand information.”</blockquote>
      </section>

      <section className="about-pillars shell">
        <header><p className="eyebrow">Our Approach</p><h2>Choose.<br />Wear. Move.</h2></header>
        <div className="about-pillars__grid">
          <article><span>01</span><h3>Footwear only</h3><p>No bags or accessories: the entire shop is dedicated to shoes and boots.</p></article>
          <article><span>02</span><h3>Useful product pages</h3><p>Photos, sizes, materials and fit guidance are all in one place.</p></article>
          <article><span>03</span><h3>Varied silhouettes</h3><p>Sneakers, loafers, boots, flats and sandals suit different seasons and occasions.</p></article>
          <article><span>04</span><h3>Clear pricing</h3><p>Prices are shown in GBP and remain between £170 and £220.</p></article>
        </div>
      </section>

      <section className="about-numbers">
        <div className="shell">
          <article><b>30</b><span>footwear styles</span></article>
          <article><b>1</b><span>category: shoes & boots</span></article>
          <article><b>GBP</b><span>throughout the site</span></article>
        </div>
      </section>

      <section className="about-final shell">
        <div><p className="eyebrow">Your turn</p><h2>Step into your next style.</h2></div>
        <Link className="btn" to="/shop">Explore the collection <FiArrowRight /></Link>
      </section>
    </main>
  );
}

export default About;
